/**
 * Back to Top Button
 *
 * Floating button that appears after scrolling down and smooth-scrolls
 * back to the top using the global Lenis instance.
 */

const SCROLL_THRESHOLD = 400;

function createButton() {
	const btn = document.createElement('button');
	btn.className = 'back-to-top';
	btn.setAttribute('aria-label', 'Back to top');
	btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M10 16V4M10 4L4 10M10 4L16 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>`;
	document.body.appendChild(btn);
	return btn;
}

function init() {
	const btn = createButton();

	const updateVisibility = () => {
		const scrollY = window.scrollY || document.documentElement.scrollTop;
		btn.classList.toggle('is-visible', scrollY > SCROLL_THRESHOLD);
	};

	window.addEventListener('scroll', updateVisibility, { passive: true });
	updateVisibility();

	btn.addEventListener('click', () => {
		if (window.lenis) {
			window.lenis.scrollTo(0, { duration: 1.2 });
		} else {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
